import { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Message, Session } from 'talkjs/all';
import { type EmergencyCall } from './emergencyCalls.types';
import {
  setCollaboratorIsUnread,
  type StateWithEmergencyCalls,
} from './emergencyCallsSlice';

const useHandleUnreadCollaborator = (session: Session | null) => {
  const dispatch = useDispatch();
  const callQueue = useSelector(
    (state: StateWithEmergencyCalls) => state.emergencyCalls.callQueue,
  );
  const conversationListenerSetup = useRef(false);
  const callQueueRef = useRef<Record<string, EmergencyCall>>(callQueue);

  // Update a reference to conversations so the session useEffect is up to date
  useEffect(() => {
    callQueueRef.current = callQueue;
  }, [callQueue]);

  // onMessage() functions stack not replace. Thus, need to ensure only gets called ONCE
  useEffect(() => {
    if (!session?.onMessage || conversationListenerSetup.current) {
      return;
    }

    conversationListenerSetup.current = true;

    session.onMessage((message: Message) => {
      const conversationID: string = message.conversation.id;
      const queue = callQueueRef.current;

      const matchingCall = Object.keys(callQueueRef.current).find(callerID => {
        return queue[callerID].collaborator?.conversationID === conversationID;
      });

      if (matchingCall) {
        dispatch(
          setCollaboratorIsUnread({
            callerID: matchingCall,
            isUnread: true,
          }),
        );
      }
    });

    return () => {
      conversationListenerSetup.current = false;
    };
  }, [dispatch, session]);
};

export default useHandleUnreadCollaborator;
